import * as React from 'react';

// COMPONENTS
import Button from '../../components/Button';

// PACKAGES;
import ReactPlayer from 'react-player';

//TYPES
import { closeModalType } from '../../components/GlobalModal';

interface VideoModalTypes {
	videoEmbedCode?: string;
	closeModal?: closeModalType;
}

const VideoModal: React.FC<VideoModalTypes> = ({ videoEmbedCode, closeModal }) => {
	return (
		<div className="video-container">
			<ReactPlayer className="embed-video" url={videoEmbedCode} controls />

			<div className="form-button-group">
				<Button onClick={closeModal} className="btn-primary w-100">
					Close
				</Button>
			</div>
		</div>
	);
};

export default VideoModal;
